import { FormControl, Validators } from '@angular/forms';
import { UtilMasks } from '../utils/util-masks';
import { UtilValidators } from '../utils/util-validators';
import { distinctUntilChanged } from 'rxjs/operators';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-laudo',
    templateUrl: './clean.html',
    styleUrls: ['./clean.scss']
  })
export class LaudoInput {

    @Input() selectChange;

    value: any = null;

    id: any = null;
    formId: any = null;
    label: string = '';
    name: string = null;
    mask = { mask: false, guide: false };
    control: FormControl;
    required: boolean = false;
    validators = [];
    type:string;
    options: any[] = [];
    preview;
    events: any[] = [];
    //dados requisicao
    timestamp: any;
    loading: boolean = false;
    updateError: boolean = false;
    updateErrorMsg: string = '';
    source: any = null;
    status:string|number = '';
    option: any = null;

    constructor() {}
    
    set(e, options:[] = []) {
        this.id = e.id || '';
        this.name = e.name || '';
        this.formId = e.formId || null;
        this.label = e.label || '';
        this.type = (e.type || 'TEXT').toUpperCase();
        this.value = e.value;
        this.timestamp = e.timestamp || new Date().getTime().toString();
        this.loading = e.loading || false;
        this.updateError = e.updateError || false;
        this.updateErrorMsg = e.updateErrorMsg || '';
        this.source = e.source || null;
        this.preview = e.preview || null;
        this.events = e.events || [];
        this.options = options;
        this.setValidators(e.validators || []);
        this.setMask(e.mask || null);
        this.setFormControl(this.value, e.disabled);
        this.setOption();
        this.setStatus();
    }

    private setMask(mask) {
        try {
            if (mask != null && UtilMasks[mask]) {
                this.mask = { mask: UtilMasks[mask], guide: false }
            }
        } catch (e) {
            console.error('erro ao setar mascara => ', e, 'mascara: ', mask, 'laudoInputClass: ', this);
        }
    }

    private setValidators(validators = []) {
        validators.forEach(v => {
            switch (v) {
                case 'required':
                    this.validators.push(Validators.required);
                    this.required = true;
                    break;


                case 'chassi': 
                    this.validators.push(Validators.minLength(5));
                    this.validators.push(Validators.maxLength(17));
                    break;


                case 'renavam':
                    this.validators.push(Validators.minLength(11));
                    this.validators.push(Validators.maxLength(11));
                    break;
                    

                default:
                    if (Validators[v]) {
                        this.validators.push(Validators[v]);
                    } else if (UtilValidators[v]) {
                        this.validators.push(UtilValidators[v]);
                    } else {
                        console.error('Validador não encontrado: ', v, '  laudoInputClass: ', this);
                    }
                    break;
            }

        });
    }
    
    setOption() {
        if(this.options && this.options.length>0) {
            this.option = this.options.find(opt => opt.value === this.value );
        }
    }

    setStatus() {
        if(this.option) {
            this.status = this.option.status;
        }
    }

    private setFormControl(value, disabled) {
        this.control = new FormControl({value: value, disabled: disabled}, this.validators);
        this.control.valueChanges.pipe(distinctUntilChanged()).subscribe( v => {
            this.value = v;
            if(this.options.length>0) {
                this.setOption();
                this.setStatus();
            }
        });
    }

}